<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Extractions et Synthèses</strong>
      </b-card-header>
      <b-card-body>
        <div class="row">
          <div class="col-md-4"
               v-if="canExtract(rules.EXTRACT_DONNES_GENERIQUES) || canExtract(rules.EXTRACT_CONTRATS_ACTIFS) || canExtract(rules.EXTRACT_UTILISATEURS_CEV)">
            <h5>Requêtes sur les SIREN</h5>
            <span v-if="canExtract(rules.EXTRACT_DONNES_GENERIQUES)">
              - <a @click="downloadDonneesGeneriques" class="bleu_clair">Données Génériques</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_CONTRATS_ACTIFS)">
              - <a @click="downloadContratsActifs" class="bleu_clair">Liste des Contrats Actifs et Inactifs</a><br>
            </span>
          </div>
          <div class="col-md-4"
               v-if="canExtract(rules.EXTRACT_EFFECTIFS_SIREN) || canExtract(rules.EXTRACT_CODES_POPULATIONS)">
            <h5>Requêtes sur les Populations assurées</h5>
            <span v-if="canExtract(rules.EXTRACT_EFFECTIFS_SIREN)">
              - <a @click="downloadSirenEffectif" class="bleu_clair"> Effectifs par SIREN-Produit</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_CODES_POPULATIONS)">
              - <a @click="downloadCodesPopulations" class="bleu_clair"> Codes-Populations en cours</a><br>
            </span>
          </div>
          <div class="col-md-4"
               v-if="canExtract(rules.EXTRACT_MAJ_CODES_PRODUITS) || canExtract(rules.EXTRACT_CODES_PRODUITS) || canExtract(rules.EXTRACT_LIBELLES_POPULATION)">
            <h5>Codes-Produits et Libellés de Population</h5>
            <span v-if="canExtract(rules.EXTRACT_MAJ_CODES_PRODUITS)">
              - <i>Mise à jour des Codes-Produits (N.D.)</i><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_CODES_PRODUITS)">
              - <a @click="downloadCodesProduits" class="bleu_clair">Extraction des Codes-Produits</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_LIBELLES_POPULATION)">
              - <a @click="downloadLibellesPopulation" class="bleu_clair">Extraction des Libellés de Population</a><br>
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-4"
               v-if="canExtract(rules.EXTRACT_SAISIES_DOSSIERS) || canExtract(rules.EXTRACT_SAISIES_DOSSIERS_RGPD) || canExtract(rules.EXTRACT_DOSSIERS_INCIDENT_RGPD) || canExtract(rules.EXTRACT_DOSSIERS_JOURNAL_STATUS) || canExtract(rules.EXTRACT_DOSSIERS_DPC) || canExtract(rules.EXTRACT_DOSSIERS_DBCO) || canExtract(rules.EXTRACT_CHARGEMENT_BPIJ) || canExtract(rules.EXTRACT_AR_COURRIER_DBCO) || canExtract(rules.EXTRACT_DOSSIERS_JOURNAL)  || canExtract(rules.EXTRACT_DOSSIER_REOPEN)">
            <h5>Pilotage Dossiers</h5>
            <span v-if="canExtract(rules.EXTRACT_SAISIES_DOSSIERS)">
              - <a href="/espace-gestion/extractions/extraction-saisie" target="_BLANK" class="bleu_clair"> Extraction des saisies par date</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_SAISIES_DOSSIERS_RGPD)">
              - <a href="/espace-gestion/extractions/extraction-saisie-rgpd" target="_BLANK" class="bleu_clair"> Extraction des saisies par date (RGPD OK)</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_DOSSIERS_INCIDENT_RGPD)">
              - <a href="/espace-gestion/extractions/extraction-dossier-incident-rgpd" target="_BLANK" class="bleu_clair"> Extraction des dossiers par date avec incidents (RGPD OK)</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_DOSSIERS_JOURNAL_STATUS)">
              - <a href="/espace-gestion/extractions/extraction-dossier-journal-status" target="_BLANK" class="bleu_clair"> Extraction des changements de statut via le journal</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_DOSSIERS_JOURNAL)">
              - <a href="/espace-gestion/extractions/extraction-dossier-journal" target="_BLANK" class="bleu_clair"> Extraction du journal des dossiers</a><br>
            </span>
            <!-- <span v-if="canExtract(rules.EXTRACT_DOSSIERS_PRODUIT_STATUS)">
              - <a href="/espace-gestion/extractions/extraction-dossier-produit-status" target="_BLANK" class="bleu_clair"> Extraction des dossiers par produit et statut</a><br>
            </span> -->
            <span v-if="canExtract(rules.EXTRACT_DOSSIERS_DPC)">
              - <a href="/espace-gestion/extractions/extraction-dossier-dpc" target="_BLANK" class="bleu_clair"> Extraction des dossiers DPC</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_DOSSIERS_DBCO)">
              - <a href="/espace-gestion/extractions/extraction-dossier-dbco" target="_BLANK" class="bleu_clair"> Extraction des dossiers DBCO</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_AR_COURRIER_DBCO)">
              - <a href="/espace-gestion/extractions/extraction-ar-courrier-dbco" target="_BLANK" class="bleu_clair"> Extraction des AR courrier DBCO</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_CHARGEMENT_BPIJ)">
              - <a href="/espace-gestion/extractions/chargement-bpij" target="_BLANK" class="bleu_clair">  Extraction des chargements BPIJ</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_DOSSIER_REOPEN)">
              - <a href="/espace-gestion/extractions/dossier-reopen" target="_BLANK" class="bleu_clair">  Extraction des dossiers qui ont eu une réouverture</a><br>
            </span>
            <span >
              - <a  @click="downloadStoreParProduit" class="bleu_clair">  Extraction du stock (à traiter/ à affecter /en attente) par produit</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_DOSSIER_JA_N_1)">
              - <a href="/espace-gestion/extractions/dossier-ja-n-1" target="_BLANK" class="bleu_clair">  Extraction des dossiers qui ont une pj JA N-1</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_DOSSIER_INVAL_RESOURCE)">
              - <a href="/espace-gestion/extractions/inval-ressource" target="_BLANK" class="bleu_clair">  Extraction des dossiers Inval avec information attestation de ressource</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_STOCK_DOSSIERS)">
              - <a  @click="downloadStockParGarantie" class="bleu_clair">  Extraction du stock des dossiers par garantie</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_DOSSIERS_TRAITES)">
              - <a  @click="downloadDossiersTraites" class="bleu_clair"> Extraction des dossiers traités</a><br>
            </span>
          </div>
          <div class="col-md-4"
               v-if="canExtract(rules.EXTRACT_PORTEFEUILLE_PRODUIT) || canExtract(rules.EXTRACT_PORTEFEUILLE_TAILLE) || canExtract(rules.EXTRACT_PORTEFEUILLE_SIRH)">
            <h5>Synthèses sur le portefeuille</h5>
            <span v-if="canExtract(rules.EXTRACT_PORTEFEUILLE_PRODUIT)">
              - <a href="/espace-gestion/extractions/synthese-produit" target="_BLANK" class="bleu_clair">  Synthèse par produit</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_PORTEFEUILLE_TAILLE)">
              - <a href="/espace-gestion/extractions/synthese-structure" target="_BLANK" class="bleu_clair">  Synthèse par taille de structure</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_PORTEFEUILLE_SIRH)">
              - <a href="/espace-gestion/extractions/synthese-sirh" target="_BLANK" class="bleu_clair">  Synthèse par SIRH</a><br>
            </span>
          </div>
          <div class="col-md-4"
               v-if="canExtract(rules.EXTRACT_ANOMALIES_SIREN_NIC) || canExtract(rules.EXTRACT_ANOMALIES_DOUBLON_PM)
                || canExtract(rules.EXTRACT_ANOMALIES_SOUSCRIPTEURS_MULTIPLES) || canExtract(rules.EXTRACT_ANOMALIES_PRODUITS)
                || canExtract(rules.EXTRACT_ANOMALIES_CODES_POPULATIONS)">
            <h5> Anomalies détectées au chargement </h5>
            <span v-if="canExtract(rules.EXTRACT_ANOMALIES_SIREN_NIC)">
              - <a href="/espace-gestion/extractions/anomalie-siren-nic" target="_BLANK" class="bleu_clair">  Liste des SIREN et NIC en anomalie </a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_ANOMALIES_DOUBLON_PM)">
              - <i> Liste des Doublons de PM (N.D.)</i><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_ANOMALIES_SOUSCRIPTEURS_MULTIPLES)">
              - <a href="/espace-gestion/extractions/anomalie-souscripteur" target="_BLANK" class="bleu_clair"> Liste des Souscripteurs Multiples</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_ANOMALIES_PRODUITS)">
              - <a href="/espace-gestion/extractions/anomalie-produit"  target="_BLANK" class="bleu_clair"> Liste des Produits en anomalie</a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_ANOMALIES_CODES_POPULATIONS)">
              - <i> Liste des Codes-Populations en anomalie (N.D.)</i><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_ANOMALIES_PRODUITS)">
              - <a href="/espace-gestion/extractions/ecarts-libelles-blocage" target="_BLANK" class="bleu_clair"> Liste des écarts entre libellés blocage</a>
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-4" v-if="canExtract(rules.EXTRACT_BASE_AFFILIATION)">
            <h5> Base Affiliation </h5>
            <span v-if="canExtract(rules.EXTRACT_BASE_AFFILIATION)">
              - <a href="/espace-gestion/extractions/base-affiliation" target="_BLANK" class="bleu_clair"> Extraction base Affiliation </a><br>
            </span>
            <span v-if="canExtract(rules.EXTRACT_BASE_AFFILIATION)">
              - <a href="/espace-gestion/extractions/base-affiliation-nic" target="_BLANK" class="bleu_clair"> Extraction base Affiliation avec NIC</a><br>
            </span>
          </div>
          <div class="col-md-4" v-if="canExtract(rules.EXTRACT_DECLARATION_AT_CEV)">
            <h5> Déclaration AT CeV </h5>
            <span v-if="canExtract(rules.EXTRACT_DECLARATION_AT_CEV)">
              - <a href="/espace-gestion/extractions/declaration-at-cev" target="_BLANK" class="bleu_clair"> Extraction par SIREN </a><br>
            </span>
          </div>
          <div class="col-md-4" v-if="canExtract(rules.EXTRACT_DECLARATION_AT_CEV)">
            <h5> Utilisateurs CEV </h5>
            <span v-if="canExtract(rules.EXTRACT_UTILISATEURS_CEV)">
              - <a @click="downloadCevUsers" class="bleu_clair"> Extraction utilisateurs CeV </a><br>
            </span>
          </div>
          <!-- <div class="col-md-4" v-if="canExtract(rules.EXTRACT_DECOMPTES)">
            <h5> Décompte </h5>
            <span v-if="canExtract(rules.EXTRACT_DECOMPTES)">- <i>Extraction des décomptes par date (N.D. voir DGPo)</i></span>
          </div> -->
        </div>
        <div class="row mt-3">
          <div class="col-md-4" v-if="canExtract(rules.EXTRACT_USER_ATLAS)">
            <h5> Utilisateur ATLAS </h5>
            <span v-if="canExtract(rules.EXTRACT_USER_ATLAS)">
              - <a href="/espace-gestion/extractions/user-atlas" target="_BLANK" class="bleu_clair"> Extraction des utilisateurs ATLAS </a><br>
            </span>
          </div>
          <div class="col-md-4" v-if="canExtract(rules.EXTRACT_FICHE_TEL_DGPO)">
            <h5> Fiche téléphonique Dgpo </h5>
            <span v-if="canExtract(rules.EXTRACT_FICHE_TEL_DGPO)">
              - <a href="/espace-gestion/extractions/fiche-tel-dgpo" target="_BLANK" class="bleu_clair"> Extraction des fiches téléphoniques </a><br>
            </span>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {extractionRules, hasRule} from "@/utils/rulesHelper";
  import {downloadFile, isEmpty} from "@/utils/fileHelper";

  export default {
    name: "List",
    data() {
      let self = this;
      return {
        rules: extractionRules,
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      // this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      canExtract(rule) {
        return hasRule(rule);
      },
      downloadDonneesGeneriques() {
        this.triggerExport('extract_generique', 'donnees_generiques', 'csv');
      },
      downloadContratsActifs() {
        this.triggerExport('extract_contrats_actifs', 'contrats_actifs', 'xlsx');
      },
      downloadSirenEffectif() {
        this.triggerExport('extract_siren_effectif', 'siren_effectif', 'xlsx');
      },
      downloadCodesPopulations() {
        this.triggerExport('extract_code_pop', 'codes_populations', 'xlsx');
      },
      downloadCodesProduits() {
        this.triggerExport('extract_code_prod', 'codes_produits', 'xlsx');
      },
      downloadLibellesPopulation() {
        this.triggerExport('extract_lib_pop', 'libelles_population', 'xlsx');
      },
      downloadStoreParProduit() {
        let date = new Date();
        let fileName = 'stock_par_produit_' + date.toLocaleDateString("fr-FR");
        this.triggerExport('extract_stock_par_produit', fileName, 'csv');
      },
      downloadStockParGarantie(){
        let date = new Date();
        let fileName = 'stock_par_garantie_' + date.toLocaleDateString("fr-FR");
        this.triggerExport('extract_stock_par_garantie', fileName, 'csv');
      },
      downloadDossiersTraites(){
        let date = new Date();
        let fileName = 'dossiers_traites_J-1' + date.toLocaleDateString("fr-FR");
        this.triggerExport('extract_dossiers_traites', fileName, 'csv');
      },
      downloadCevUsers(){
        let date = new Date();
        let fileName = 'extraction_utilisateurs_cev' + date.toLocaleDateString("fr-FR");
        this.triggerExport('extract_utilisateurs_cev', fileName, 'csv');
      },
      triggerExport(url, filename, extension) {
        let self = this
        extension = isEmpty(extension) ? 'xlsx' : extension;

        this.$store.commit('IS_LOADING', true);

        if (!isEmpty(process.env.VUE_APP_MIDDLE_EXTRACT_URL)) {
          this.$axios.defaults.baseURL = process.env.VUE_APP_MIDDLE_EXTRACT_URL;
        }

        this.$axios.get(`/espaceGestion/extractions/${url}`, {responseType: 'arraybuffer'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, filename, extension);
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            console.log(error);
            let errorText = "Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI."
            if (error.response.status === 403) {
              errorText = "Vous n'êtes pas autorisé à effectuer cette action"
            }
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
    }
  }
</script>

<style scoped>
  .bleu_clair {
    cursor: pointer;
    color: #1e8eb5 !important;
    text-underline: #1e8eb5 !important;
  }
</style>
